"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var NavTreeItem_1 = __importDefault(require("../NavTreeItem/NavTreeItem"));
var Tree_1 = __importDefault(require("../Tree/Tree"));
var l10n_1 = require("@paprika/l10n");
require("./NavTree.scss");
var NavTree = function (_a) {
    var items = _a.items, expanded = _a.expanded, onCaretClick = _a.onCaretClick, onNavigate = _a.onNavigate, noSearchResults = _a.noSearchResults, searchIds = _a.searchIds, searchValues = _a.searchValues;
    var i18n = l10n_1.useI18n();
    var handleCaretClick = function (type, id) {
        var newExpanded = __assign({}, expanded);
        if (!newExpanded[type]) {
            newExpanded[type] = [];
        }
        var index = newExpanded[type].indexOf(id);
        if (index > -1) {
            newExpanded[type].splice(index, 1);
        }
        else {
            newExpanded[type].push(id);
        }
        onCaretClick(newExpanded);
    };
    var renderLabel = function (item, expanded, parentType) { return (react_1.default.createElement(NavTreeItem_1.default, __assign({}, item, { expanded: expanded, location: location, onCaretClick: handleCaretClick, onLinkClick: onNavigate, searchValues: searchValues, parentType: parentType }))); };
    var tree = noSearchResults ? (react_1.default.createElement("div", { className: "results-panel__no-search-results" }, i18n.t('left_navigation.no_search_results'))) : (react_1.default.createElement(Tree_1.default, { items: items, searchIds: searchIds, expanded: expanded, renderLabel: renderLabel }));
    return react_1.default.createElement("nav", { className: "results-nav" }, tree);
};
NavTree.propTypes = {
    items: prop_types_1.default.arrayOf(prop_types_1.default.object).isRequired,
    expanded: prop_types_1.default.object.isRequired,
    onCaretClick: prop_types_1.default.func.isRequired,
    onNavigate: prop_types_1.default.func.isRequired,
    noSearchResults: prop_types_1.default.bool.isRequired,
    searchIds: prop_types_1.default.object,
    searchValues: prop_types_1.default.array,
    locale: prop_types_1.default.string,
};
exports.default = NavTree;
//# sourceMappingURL=NavTree.js.map